module.exports = __webpack_public_path__ + "img/facebook.e59a7938.png";